(function(){
  function setActiveTab(section, selected){
    var buttons = section.querySelectorAll('[data-filter-button]');
    var panels = section.querySelectorAll('[data-rate-panel]');

    buttons.forEach(function(button){
      var active = button.getAttribute('data-filter-button') === selected;
      button.classList.toggle('is-active', active);
      button.setAttribute('aria-selected', active ? 'true' : 'false');
      button.setAttribute('tabindex', active ? '0' : '-1');
    });

    panels.forEach(function(panel){
      panel.hidden = panel.getAttribute('data-rate-panel') !== selected;
    });
  }

  function focusTab(section, currentButton, direction){
    var buttons = Array.prototype.slice.call(section.querySelectorAll('[data-filter-button]'));
    var currentIndex = buttons.indexOf(currentButton);
    var nextIndex;

    if(direction === 'first') nextIndex = 0;
    else if(direction === 'last') nextIndex = buttons.length - 1;
    else nextIndex = (currentIndex + direction + buttons.length) % buttons.length;

    var nextButton = buttons[nextIndex];
    if(!nextButton) return;
    setActiveTab(section, nextButton.getAttribute('data-filter-button'));
    nextButton.focus();
  }

  function bindSection(section){
    if(!section || section.dataset.tabsBound === 'true') return;
    section.dataset.tabsBound = 'true';

    section.addEventListener('click', function(event){
      var button = event.target.closest('[data-filter-button]');
      if(!button || !section.contains(button)) return;
      setActiveTab(section, button.getAttribute('data-filter-button'));
    });

    section.addEventListener('keydown', function(event){
      var button = event.target.closest('[data-filter-button]');
      if(!button || !section.contains(button)) return;

      if(event.key === 'ArrowRight'){
        event.preventDefault();
        focusTab(section, button, 1);
      } else if(event.key === 'ArrowLeft'){
        event.preventDefault();
        focusTab(section, button, -1);
      } else if(event.key === 'Home'){
        event.preventDefault();
        focusTab(section, button, 'first');
      } else if(event.key === 'End'){
        event.preventDefault();
        focusTab(section, button, 'last');
      }
    });

    var activeButton = section.querySelector('[data-filter-button].is-active') || section.querySelector('[data-filter-button]');
    if(activeButton) setActiveTab(section, activeButton.getAttribute('data-filter-button'));
  }

  function init(){
    document.querySelectorAll('[data-shipping-options-policies]').forEach(bindSection);
  }

  if(document.readyState === 'loading'){
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
